import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-39b0d387"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-video-info" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "btn-box" }
const _hoisted_7 = { class: "control" }
const _hoisted_8 = { class: "focal" }
const _hoisted_9 = { class: "right" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "问题清单", -1))

import Bus from '@/config/Bus'
import {
  h,
  toRefs,
  nextTick,
  getCurrentInstance,
  onMounted,
  onBeforeUnmount,
} from 'vue'
import Video from 'video.js'
import { useMessage } from 'naive-ui'
import { ref } from 'vue-demi'
import { Api } from '@/api/publicApi'
import VideoPlayerHk from '@/components/common/VideoPlayerHk.vue'
import { useMainStore } from '@/store/main'
import pinia from '@/store/index'
import { AnyLayout } from 'mapbox-gl'


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogVideoInfoHK',
  props: {
  data: Object,
},
  setup(__props) {

const mainStore = useMainStore(pinia)

const videoPlayer = ref(null)
const props = __props
const api = new Api()
const message = useMessage()
const tilt = ref(false)
const columns = ref([
  {
    title: '序号',
    key: 'no',
    width: 60,
    align: 'center',
    render(row, index) {
      return h(
        `span`,
        {},
        {
          default: () => index + 1,
        }
      )
    },
  },
  {
    title: '时间',
    key: 'reportTime',
    width: 120,
    align: 'center',
  },
  {
    title: '名称',
    key: 'problemName',
    align: 'center',
  },
  {
    title: '类别',
    key: 'aiTypeStr',
    width: 120,
    align: 'center',
  },
  {
    title: '状态',
    key: 'problemStatus',
    width: 80,
    align: 'center',
    render(row, index) {
      let className = 'tag dcl'
      if (row.problemStatus === 1) {
        className = 'tag dcl'
      }
      if (row.problemStatus === 2) {
        className = 'tag clz'
      }
      if (row.problemStatus === 3) {
        className = 'tag ywj'
      }
      return h(
        `div`,
        {
          class: className,
        },
        {
          default: () => row.problemStatusStr,
        }
      )
    },
  },
])
const tableData = ref([])
const problemTypeObj = []
const controlShow = ref(false)
const multiplyShow = ref(false)
const params = {
  action: 1,
  command: 'UP',
}
const deviceList = ref([])
const deviceInfo = ref({
  hkVideo: true,
})
const videoContainer = ref()
const video = ref()
let customInterval = null
let player: {
  dispose: () => void
  on: (arg0: string, arg1: () => void) => void
  play: () => void
  ready: (arg0: () => void) => void
  currentTime: (arg0: number) => void
}

// 获取问题列表
const getProblemList = () => {}
const getProblemTypeStr = (data1) => {
  for (let i = 0; i < problemTypeObj.length; i += 1) {
    if (parseInt(problemTypeObj[i].value, 10) === data1) {
      return problemTypeObj[i].name
    }
  }
  return ''
}
/**
 * @description: 获取视频信息
 * @event:
 * @param {*}
 * @return {*}
 */
const getVideo = () => {
  // eslint-disable-next-line no-undef
  console.log('getVideo', props.data)
  api.screen.getAiListByIdUsingPost({ id: props.data.id }).then((res) => {
    if (res.code === 200) {
      tableData.value = res.data
    }
  })
  setTimeout(() => {
    if (tilt.value) {
      api.screen.cameraWsStreamByIdUsingPost({ id: props.data.id }).then((res) => {
        if (res.code === 200) {
          deviceList.value = [res.data]
          deviceInfo.value = res.data
          deviceInfo.value.deviceName = props.data.name
          // if (deviceInfo.value.hkVideo && tilt.value) {
          //   const curIndex = 0 // 当前窗口下标
          //   // eslint-disable-next-line no-undef
          //   const myPlugin = new JSPlugin({
          //     szId: 'play_window', //需要英文字母开头 必填
          //     szBasePath: './', // 必填,引用H5player.min.js的js相对路径
          //   })
          //   let startTime, endTime
          //   myPlugin.JS_Play(
          //     deviceInfo.value.videoStream,
          //     {
          //       playURL: deviceInfo.value.videoStream, // 流媒体播放时必传
          //       mode: 0, // 解码类型：0=普通模式; 1=高级模式 默认为0
          //       // 设置直连时的认证参数等
          //       // ...
          //     },
          //     curIndex
          //   )
          // } else {
            if (player) {
              player.dispose()
            }
            const video = document.createElement('video');
            video.setAttribute('style', 'width: 100%; height: 100%');
            video.setAttribute('class', 'video video-js vjs-default-skin vjs-big-play-centered');
            video.setAttribute('id', 'pop_video');
            videoContainer.value.appendChild(video);
            setTimeout(() => {
              const option = {
                muted: false,
                controls: true,
                loop: false,
                autoplay: false,
                sources: [
                  {
                    type: '',
                    src: deviceInfo.value.videoStream, // url地址
                  },
                ],
                notSupportedMessage: '此视频暂无法播放，请稍后再试',
                // poster:,
                // src: 'blob:https://www.bilibili.com/81b9cf25-01f8-4ac5-b8be-7f9b4f07fa8b',
              }
              // 初始化的时候标签默认都是显示的
              player = Video('pop_video', option, () => {
                player.on('error', () => {
                  player.errorDisplay.contentEl().innerText = '现场视频断流，请稍后重试！'
                  console.log('视频加载错误')
                })
              })
              player.play()
            }, 1000)
          }
        // }
      })
    } else {
      api.screen.getCameraStreamListByIdUsingPost({ id: props.data.id }).then((res) => {
        if (res.code === 200) {
          deviceList.value = res.data
          deviceInfo.value = res.data[0]
          // if (deviceInfo.value.hkVideo && !tilt.value) {
          //   console.log('deviceInfo.value.hkVideo ----------', videoPlayer.value)
          //   setTimeout(() => {
          //     videoPlayer.value.initPlugin(deviceInfo.value.deviceId)
          //   }, 1000)
          // } else {
            if (player) {
              player.dispose()
            }
            const video = document.createElement('video');
            video.setAttribute('style', 'width: 100%; height: 100%');
            video.setAttribute('class', 'video video-js vjs-default-skin vjs-big-play-centered');
            video.setAttribute('id', 'pop_video');
            videoContainer.value.appendChild(video);
            setTimeout(() => {
              const option = {
                muted: false,
                controls: true,
                loop: false,
                autoplay: false,
                sources: [
                  {
                    type: '',
                    src: deviceInfo.value.videoStream, // url地址
                  },
                ],
                notSupportedMessage: '此视频暂无法播放，请稍后再试',
                // poster:,
                // src: 'blob:https://www.bilibili.com/81b9cf25-01f8-4ac5-b8be-7f9b4f07fa8b',
              }
              // 初始化的时候标签默认都是显示的
              player = Video('pop_video', option, () => {
                player.on('error', () => {
                  player.errorDisplay.contentEl().innerText = '现场视频断流，请稍后重试！'
                  console.log('视频加载错误')
                })
              })
              player.play()
            }, 1000)
          }
        // }
      })
    }
  }, 500)
}

//切换设备
const changDevice = (e: any) => {
  // if (videoPlayer.value) {
  //   videoPlayer.value.stopAllPreview()
  // }
  // setTimeout(() => {
  //   if (player) {
  //     player.dispose()
  //   }
  // }, 200)
  deviceInfo.value = deviceList.value[e.target.selectedIndex]
  // if (deviceInfo.value.hkVideo && !tilt.value) {
  //   setTimeout(() => {
  //     videoPlayer.value.initPlugin(deviceInfo.value.deviceId)
  //   }, 100)
  // } else {
    setTimeout(() => {
      // if (player.src) {
      //   player.src({ src: deviceInfo.value.videoStream })
      // } else {
        if (player) {
          player.dispose()
        }
        const video = document.createElement('video');
        video.setAttribute('class', 'video video-js vjs-default-skin vjs-big-play-centered');
        video.setAttribute('style', 'width: 100%; height: 100%');
        video.setAttribute('id', 'pop_video');
        videoContainer.value.appendChild(video);
        const option = {
          muted: false,
          controls: true,
          loop: false,
          autoplay: false,
          sources: [
            {
              type: '',
              src: deviceInfo.value.videoStream, // url地址
            },
          ],
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
          // poster:,
          // src: 'blob:https://www.bilibili.com/81b9cf25-01f8-4ac5-b8be-7f9b4f07fa8b',
        }
        // 初始化的时候标签默认都是显示的
        player = Video('pop_video', option, () => {
          player.on('error', () => {
            player.errorDisplay.contentEl().innerText = '现场视频断流，请稍后重试！'
            console.log('视频加载错误')
          })
        })
      // }
      player.play()
    }, 1000)
  // }
}

// 云台控制
const control = () => {
  multiplyShow.value = false
  controlShow.value = !controlShow.value
}

/** 监控控制 */
const directioControl = (val) => {
  // console.log(val)
  // console.log(props.data)
  if (!deviceInfo.value.deviceId) {
    return
  }
  params.cameraIndexCode = deviceInfo.value.deviceId
  switch (val) {
    case 'stop':
      params.action = 1
      break
    case 'top':
      params.action = 0
      params.command = 'UP'
      break
    case 'right':
      params.action = 0
      params.command = 'RIGHT'
      break
    case 'bottom':
      params.action = 0
      params.command = 'DOWN'
      break
    case 'left':
      params.action = 0
      params.command = 'LEFT'
      break
    case 'enlarge':
      params.action = 0
      params.command = 'ZOOM_IN'
      break
    case 'narrow':
      params.action = 0
      params.command = 'ZOOM_OUT'
      break
    default:
  }
  api.screen.controllingUsingPost(params).then((res) => {
    // console.log(res)
    if (res.code == 500) {
      message.warning('该设备暂不支持此功能')
    }
  })
}

// 问题详情
const problemDetails = (row: any) => {
  return {
    style: 'cursor: pointer;',
    onClick: () => {
      // setTimeout(() => {
      //   if (videoPlayer.value) {
      //     videoPlayer.value.hideVideoPlayer()
      //   }
      // }, 200)
      // clearInterval(customInterval)
      // customInterval = setInterval(() => {
      //   if (videoPlayer.value) {
      //     videoPlayer.value.hideVideoPlayer()
      //   }
      // }, 200)
      Bus.emit('2showModal', {
        data: row,
        modalType: '问题详情',
      })
    },
  }
}

onMounted(() => {
  getVideo()
  // Bus.off('videoPlayer')
  // Bus.on('videoPlayer', () => {
  //   if (deviceInfo.value.hkVideo && !tilt.value) {
  //     clearInterval(customInterval)
  //     setTimeout(() => {
  //       videoPlayer.value.showVideoPlayer()
  //     }, 500)
  //   }
  // })
})

onBeforeUnmount(async () => {
  // Bus.off('videoPlayer')
  // clearInterval(customInterval)
  // if (videoPlayer.value) {
  //   videoPlayer.value.stopAllPreview()
  // }
  setTimeout(() => {
    if (player) {
      player.dispose()
    }
  }, 200)
})

return (_ctx: any,_cache: any) => {
  const _component_n_data_table = _resolveComponent("n-data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("select", { onChange: changDevice }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deviceList), (item, index) => {
            return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(item.deviceName), 1))
          }), 128))
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          ref_key: "videoContainer",
          ref: videoContainer,
          class: "video-box"
        }, null, 512),
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["btn", { active: _unref(controlShow) }]),
            onClick: control
          }, "云台控制", 2)
        ], 512), [
          [_vShow, _unref(deviceInfo) && _unref(deviceInfo).accessMode == 6 && _unref(tilt)]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (directioControl('top')))
          }),
          _createElementVNode("span", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (directioControl('right')))
          }),
          _createElementVNode("span", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (directioControl('bottom')))
          }),
          _createElementVNode("span", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (directioControl('left')))
          }),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (directioControl('enlarge')))
            }, "+"),
            _createElementVNode("p", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (directioControl('narrow')))
            }, "-")
          ])
        ], 512), [
          [_vShow, _unref(controlShow)]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_n_data_table, {
          "max-height": "530",
          columns: _unref(columns),
          data: _unref(tableData),
          pagination: false,
          bordered: false,
          "row-props": problemDetails
        }, null, 8, ["columns", "data"])
      ])
    ])
  ]))
}
}

})